import { render, staticRenderFns } from "./SeatingSettings.vue?vue&type=template&id=28bd1861&scoped=true&"
import script from "./SeatingSettings.vue?vue&type=script&lang=js&"
export * from "./SeatingSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28bd1861",
  null
  
)

export default component.exports